<template>
    <TagComponent 
        :value="label" 
        :variant="isCompleted ? 'success' : 'danger'" 
        :show-dot="true" 
    />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import TagComponent from '@/components/ui/tag/TagComponent.vue';

const props = defineProps<{ value: 0 | 1 | boolean | null | undefined }>();

const isCompleted = computed(() => {
    return props.value === 0 ? false : !!props.value;
});

const label = computed(() => (isCompleted.value ? 'Completed' : 'Incomplete'));
</script>
